"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionService = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
const Subject_1 = require("rxjs/Subject");
//INTERNAL LIBRARY BITS
const permissions_service_1 = require("./permissions.service");
const data_level_service_1 = require("./data-level.service");
//VARIABLE MODELS
let PermissionService = class PermissionService {
    constructor(_permissions, _dataLevel) {
        this._permissions = _permissions;
        this._dataLevel = _dataLevel;
        //declarations
        this.permission = {};
        this.permissionObservable = new Subject_1.Subject();
        this.adminBoardAccess = false;
        //initializations
        this.adminBoardPermissions = [
            "admin-user--create",
            "admin-user--update",
            "admin-organization--create",
            "admin-organization--update",
            "admin-client--create",
            "admin-client--update",
            "admin-permissions--update_mapping"
        ];
    }
    get() {
        return JSON.parse(JSON.stringify(this.permission));
    }
    getHelmColumns() {
        return {
            imps: { header: 'Imps', readonly: true },
            impsAdj: { header: 'Adjusted Imps', readonly: !this.permission['helm-metric--helm_renders---write'] },
            impsDisc: { header: 'Imp Discrep (%)', readonly: !this.permission['helm-metric--helm_renders_discrepancy---write'] },
            rev: { header: 'Rev ($)', readonly: true },
            revAdj: { header: 'Adjusted Rev ($)', readonly: !this.permission['helm-metric--helm_dfp_revenue---write'] },
            revDisc: { header: 'Rev Discrep (%)', readonly: !this.permission['helm-metric--helm_dfp_revenue_discrepancy---write'] },
            cpm: { header: 'CPM ($)', readonly: true },
            cpmAdj: { header: 'Adjusted CPM ($)', readonly: true },
            cpmDisc: { header: 'CPM Discrep (%)', readonly: true },
        };
    }
    getPermissionObservable() {
        return this.permissionObservable.asObservable();
    }
    set(pList, setPreferences = false) {
        let allPermissions = this._permissions.get();
        if (pList) {
            //resets all permissions to false
            for (var p in allPermissions) {
                this.permission[allPermissions[p].slug] = false;
            }
            //sets permissions to true for list sent to function
            for (var p in pList) {
                this.permission[pList[p]] = true;
            }
            //gives permission for user to see admin board
            for (var ap in this.adminBoardPermissions) {
                if (this.permission[this.adminBoardPermissions[ap]]) {
                    this.adminBoardAccess = true;
                    break;
                }
            }
            if (setPreferences) {
                if (this.permission['default-data-view-all']) {
                    this._dataLevel.set('all');
                }
            }
            this.permissionObservable.next({ permission: this.permission });
            return true;
        }
        return true;
    }
    //returns value for whether or not a user can access the admin board
    accessAdminBoard() {
        return this.adminBoardAccess;
    }
    accessSwitchOrg() {
        if (this.permission['admin-switch_org--self']) {
            return true;
        }
        return false;
    }
};
exports.PermissionService = PermissionService;
exports.PermissionService = PermissionService = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [permissions_service_1.PermissionsService,
        data_level_service_1.DataLevelService])
], PermissionService);
//# sourceMappingURL=permission.service.js.map